import loginSection from "../../components/loginSection/index.vue";

export default {
    name: "loginPage",
    components: {
        loginSection
    },
    methods: {}
};